export const macros: Record<string, string> = {
  infty: '\u221e',

  // named functions
  log: 'log',
  ln: 'ln',
  arg: 'arg',
  min: 'min',
  max: 'max',
  mod: 'mod',
  lcm: 'lcm',
  gcd: 'gcd',
  limsup: 'limsup',
  liminf: 'liminf',
  lim: 'lim',

  // linear algebra
  span: 'span',
  rank: 'rank',
  null: 'null',
  adj: 'adj',
  proj: 'proj',
  ker: 'ker',
  det: 'det',
  dim: 'dim',

  // number sets
  C: '\u2102',
  complex: '\u2102',
  H: '\u210d',
  N: '\u2115',
  naturals: '\u2115',
  P: '\u2119',
  Q: '\u211a',
  rationals: '\u211a',
  R: '\u211d',
  reals: '\u211d',
  Z: '\u2124',
  integers: '\u2124',

  // operators
  int: '\u222B',
  iint: '\u222C',
  iiint: '\u222D',
  sum: '\u2211',
  prod: '\u220f',
  pm: '\u00b1',
  mp: '\u2213',
  times: '\u00d7',
  cdot: '\u22c5',

  // relations
  neq: '\u2260',
  le: '\u2264',
  leq: '\u2264',
  ge: '\u2265',
  geq: '\u2265',
  lt: '\u003c',
  gt: '\u003e',
  in: '\u2208',
  isin: '\u2208',
  notin: '\u2209',
  ni: '\u220b',
  contains: '\u220b',
  notni: '\u220c',
  notcontains: '\u220c',
  sup: '\u2283',
  supset: '\u2283',
  superset: '\u2283',
  sub: '\u2282',
  subset: '\u2282',
  subeq: '\u2286',
  subseteq: '\u2286',
  supeq: '\u2287',
  supseteq: '\u2287',

  // arrows
  rightarrow: '\u2192',
  leftarrow: '\u2190',
  uparrow: '\u2191',
  downarrow: '\u2193',

  // accents
  vec: '\u20d7',
  hat: '\u0302',
  bar: '\u0304',
  acute: '\u0301',
  grave: '\u0300',
  tilde: '\u0303',
  dot: '\u0307',
  ddot: '\u0308',

  // trig functions
  sin: 'sin',
  cos: 'cos',
  tan: 'tan',
  cot: 'cot',
  sec: 'sec',
  csc: 'csc',
  arcsin: 'arcsin',
  arccos: 'arccos',
  arctan: 'arctan',
  arccot: 'arccot',
  arcsec: 'arcsec',
  arccsc: 'arccsc',

  // greek uppercase
  Alpha: '\u0391',
  Beta: '\u0392',
  Gamma: '\u0393',
  Delta: '\u0394',
  Epsilon: '\u0395',
  Zeta: '\u0396',
  Eta: '\u0397',
  Theta: '\u0398',
  Iota: '\u0399',
  Kappa: '\u039A',
  Lambda: '\u039B',
  Mu: '\u039C',
  Nu: '\u039D',
  Xi: '\u039E',
  Omicron: '\u039F',
  Pi: '\u03A0',
  Rho: '\u03A1',
  Sigma: '\u03A3',
  Tau: '\u03A4',
  Upsilon: '\u03A5',
  Phi: '\u03A6',
  Chi: '\u03A7',
  Psi: '\u03A8',
  Omega: '\u03A9',

  // greek lowercase
  alpha: '\u03B1',
  beta: '\u03B2',
  gamma: '\u03B3',
  delta: '\u03B4',
  epsilon: '\u03B5',
  zeta: '\u03B6',
  eta: '\u03B7',
  theta: '\u03B8',
  iota: '\u03B9',
  kappa: '\u03BA',
  lambda: '\u03BB',
  mu: '\u03BC',
  nu: '\u03BD',
  xi: '\u03BE',
  omicron: '\u03BF',
  pi: '\u03C0',
  rho: '\u03C1',
  sigma: '\u03C3',
  tau: '\u03C4',
  upsilon: '\u03C5',
  phi: '\u03C6',
  chi: '\u03C7',
  psi: '\u03C8',
  omega: '\u03C9',
};
